import React from "react";

const Footer = () => {
  return (
    <div className="bg-mainYellow p-5 flex w-full justify-center text-center text-sm text-black flex-col">
      <span> Universidad de los Andes | Vigilada Mineducación </span>
      <span> Reconocimiento como Universidad: Decreto 1297 del 30 de mayo de 1964. </span>
      <span>Reconocimiento personería jurídica: Resolución 28 del 23 de febrero de 1949 Minjusticia.</span>
      <span> © - Derechos Reservados Universidad de los Andes</span>
    </div>
  );
};

export default Footer;
